// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3agZA","left":"styles_left__lOX4Q","desktopActions":"styles_desktopActions__2Vzqk","title":"styles_title__KBeIS"};